module.exports = __webpack_public_path__ + "4f60c3ed743976474959b7882ad4e8da.png";